export default {  
    SET_CONTACTNUMBER: (state, payload) => state.contactNumbers = payload,
  }